export class StorageService {
  constructor(storage = localStorage) {
    this.storage = storage;
  }

  getItem(key) {
    const data = this.storage.getItem(key);
    try {
      return JSON.parse(data);
    } catch (e) {
      console.error(e);
      return data;
    }
  }

  setItem(key, data) {
    try {
      this.storage.setItem(key, JSON.stringify(data));
    } catch (e) {
      console.error(e);
    }
  }

  removeItem(key) {
    this.storage.removeItem(key);
  }
}

export const createLocalStorage = () => new StorageService(localStorage);

export const createSessionStorage = () => new StorageService(sessionStorage);
